import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Button, Row, Col, Radio, Checkbox, message, Form, Icon } from 'antd';
import { getShippers, fetchLinkedFFs } from 'src/api/masters';
import SearchTagsInput from 'src/components/common/SearchTagsInput';
import { inquiryModes } from '../InquiryUtils';
import { getAuthenticationHeaders } from 'src/api/utils';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import BidsBulkUploadModal from './BidsBulkUploadModal';
import { tokens } from 'src/design-system';

const styles = theme => ({
  modal: {
    '& .ant-modal-body': {
      paddingBottom: '6px',
    },
  },
  okButton: {
    backgroundColor: 'rgb(24, 144, 255)',
    border: '1px solid rgb(24, 144, 255)',
    color: tokens.colors.bgWhite,
    '&:hover': {
      backgroundColor: 'rgb(24, 144, 255)',
      border: '1px solid rgb(24, 144, 255)',
      color: tokens.colors.bgWhite,
    },
    '&:focus': {
      backgroundColor: 'rgb(24, 144, 255)',
      border: '1px solid rgb(24, 144, 255)',
      color: tokens.colors.bgWhite,
    },
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
  },
  bidInfo: {
    fontSize: `${tokens.fontSize.small}px`,
    fontStyle: 'italic',
    marginTop: '20px',
  },
});

class UploadBidsFilterModal extends React.PureComponent<any, any> {
  state: any = {
    sourceShippers: [],
    selectedShipper: '',
    isIncludeRespondedChecked: false,
    inquiryMode: 'FCL',
    isBidsBulkUploadModalVisible: false,
    headerMappingData: [],
    loading: false,
    fetchedFFs: [],
    selectedFF: '',
    orgId: '',
  };

  componentDidMount() {
    const orgId = getAuthenticationHeaders()['organisation-id'];
    this.setState({
      orgId,
    });
  }

  searchShipper: any = async (queryString) => {
    const response = await getShippers({ queryString });
    if (response.isSuccess) {
      this.setState({
        sourceShippers: response.data.map(shipper => ({
          key: shipper.id,
          label: shipper.name,
        })),
      });
    }
  }

  searchFfs = async () => {
    const { inquiryMode } = this.state;
    const response = await fetchLinkedFFs({
      organisationType: 'FF',
      mode: inquiryMode,
    });
    if (response.isSuccess) {
      this.setState({
        fetchedFFs: response.data && response.data.map((item) => {
          return {
            key: item.id,
            label: item.name,
          };
        }),
      });
    } else {
      message.error(response.errorMessage);
    }
  }

  handleClose = () => {
    const { handleCancel } = this.props;
    handleCancel();
    this.setState({
      isIncludeRespondedChecked: false,
      loading: false,
    });
  }

  handleUploadOk = () => {
    const { form } = this.props;
    form.validateFields(async (err) => {
      if (err) return;
      sendEvent(
        EventCategories.INQUIRY_BIDDING,
        'Upload Bids - Next',
      );
      this.setState({
        isBidsBulkUploadModalVisible: true,
      });
    });
  }

  handleUploadBids = () => {
    this.props.handleOk();
    this.setState({ isBidsBulkUploadModalVisible: false });
  }

  getTagsInput = () => {
    const { isShipper } = this.props;
    const { sourceShippers, fetchedFFs } = this.state;
    return isShipper ?
      <SearchTagsInput mode="default" placeholder="Select FF"
      style={{  width: '100%' }}
      options={fetchedFFs}
      onChange={(ff) => {
        this.setState({
          selectedFF: ff,
        });
      }}
      searchFunction={() => this.searchFfs()} /> :
      <SearchTagsInput mode="default" placeholder="Select Shipper"
      style={{  width: '100%' }}
      options={sourceShippers}
      onChange={(shippers) => {
        this.setState({
          selectedShipper: shippers,
        });
      }}
      searchFunction={e => this.searchShipper(e)} />;
  }

  render() {
    const { visible, classes, form : { getFieldDecorator }, isShipper } = this.props;
    const { selectedShipper, inquiryMode, isIncludeRespondedChecked,
      isBidsBulkUploadModalVisible, loading, orgId, selectedFF} = this.state;
    return (
      <Modal
        className={classes.modal}
        title="Select Details"
        visible={visible}
        onCancel={this.handleClose}
        destroyOnClose
        footer={[
          <Button key="cancel" onClick={this.handleClose}>
            Cancel
          </Button>,
          <Button key="submit" className={classes.okButton}
          onClick={this.handleUploadOk} loading={loading}>
            Next
          </Button>,
        ]}>
          <Form><Row>
            <Col span={6} style={{ marginTop: '10px' }}>
              {`${isShipper ? 'FF*' : 'Shipper*'}`}
            </Col>
            <Col span={18}>
              <Form.Item>
                {getFieldDecorator('shipper', {
                  rules: [{ required: true, message: 'Cannot be empty!' }],
                })(this.getTagsInput())}
              </Form.Item>
            </Col>
          </Row>
          <Row className={classes.filterRow}>
            <Col span={6}>Mode*</Col>
            <Col span={18}>
              <Radio.Group
                value={inquiryMode}
                onChange={(e) => {
                  this.setState({ inquiryMode: e.target.value });
                }}>
                {inquiryModes.map(option =>
                  <Radio
                  key={option.value}
                  value={option.value}
                  disabled={option.value !== 'FCL'}>{option.label}</Radio>)}
              </Radio.Group>
            </Col>
          </Row>
          </Form>
          {isBidsBulkUploadModalVisible && <BidsBulkUploadModal
            isVisible={isBidsBulkUploadModalVisible}
            onClose={() => {
              this.setState({ isBidsBulkUploadModalVisible: false });
              this.handleClose();
            }}
            inquiryMode={inquiryMode}
            isIncludeRespondedChecked={isIncludeRespondedChecked}
            selectedShipperId={isShipper ? orgId : selectedShipper && selectedShipper.key}
            isShipper={isShipper}
            selectedFF={selectedFF && selectedFF.key}
            getRequestObject={this.props.getRequestObject}
          />}
      </Modal>
    );
  }
}

export default injectSheet(styles)(Form.create()(UploadBidsFilterModal));
